import React from 'react';

import { ReactFCV } from '@types';

import { IDividerProps } from './model';
import { StyledDivider } from './styled';

export const GridDivider: ReactFCV<IDividerProps> = (props) => <StyledDivider {...props} />;
